export default () => {
	return {
		isAllHidden: false,
		isShowingAll: false,

		items: [],
		itemsSorted: [],

		init() {
			this.$watch('items', () => this.sortItems());
		},
		sortItems() {
			this.itemsSorted = [
				...this.items,
			];
		},

		hasAnyVisibleItem(){
			return this.itemsSorted.some((item) => item.count > 0);
		},

		getActualInitialCount(initialCount){
			let counter = 0;
			let found = 0;
			for (const item of this.itemsSorted) {
				if(found === initialCount){
					return counter;
				}
				if(item.count > 0){
					++found;
				}
				++counter;
			}
			return counter;
		},

		thereIsVisibleItemAfterInitialItems(actualInitialCount){
			let itemsPortion = this.itemsSorted.slice(actualInitialCount);
			console.log(itemsPortion);

			return itemsPortion.some((item) => item.count > 0);
		}
	};
};
